module.exports = __webpack_public_path__ + "media/images/fullscreen/Main-header-desktop@2x-de208d9193d51e9cf1d26caf623302db.jpg";